var map = {
	"./facebook-logo-white.svg": "5ab4",
	"./st-button-facebook-white.svg": "00c3",
	"./st-button-twitter-white.svg": "1320",
	"./st-logo-white.svg": "762e",
	"./straits-times-logo-white.svg": "3b4b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0431";